import { render, staticRenderFns } from "./DkWizardLeadFormHeader.vue?vue&type=template&id=644d122c&"
import script from "./DkWizardLeadFormHeader.vue?vue&type=script&lang=js&"
export * from "./DkWizardLeadFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports